import React from 'react';
import ReactStars from 'react-stars';
import './ReviewCart.css';

const ReviewCart = ({ review }) => {
        const { name, img, rating, reviewSpeech } = review;
        return (
                <div className="col p-4">
                        <div className="card h-100">
                                <div className="d-flex justify-content-center align-items-center rounded-top singleImg">
                                        <img src={img} className="rounded-circle border border-3 border-dark" width="180" height="180" alt="..." />
                                </div>
                                <div className="card-body text-center bg-dark">
                                        <div className="card-information">
                                                <h4 className="card-title brand-color mt-3">{name}</h4>
                                                <p className="text-white">"{reviewSpeech.slice(0, 120)}"</p>
                                        </div>
                                        <div className="mt-2 d-flex justify-content-center pb-3 align-items-center">
                                                <ReactStars
                                                        value={rating}
                                                        size={24}
                                                        edit={false}
                                                        color2={'#f25a1d'}
                                                        color1={'#FFFFFF'} />
                                                <h6 className="ps-3 mt-2 brand-color">{rating}</h6>
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default ReviewCart;